import type { Screen } from '../config/screens';
import { useScreens } from './use-screens';

export const useScreen = (screen: Screen): boolean => {
  const [screensSet] = useScreens();

  return screensSet.has(screen);
};